
export default {
  name: 'Welcome',
  props: {
    mobile: {
      type: Boolean,
      default: false
    },
    premium: {
      type: Boolean,
      default: false
    },
    company: {
      type: String,
      default: 'AirProducts'
    },
    country: {
      type: String,
      default: null
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    portalMobileTranslateId() {
      switch (this.user.salesOrg) {
        case 'GB46':
          return 'ml_132929'
        case 'GB47':
          return 'ml_132930'
        case 'GB49':
          return 'ml_132931'
      }
      return ''
    },
    portalPremiumTranslateId() {
      switch (this.user.salesOrg) {
        case 'GB46':
          return 'ml_132932'
        case 'GB47':
          return 'ml_132933'
        case 'GB49':
          return 'ml_132934'
      }
      return ''
    },
    portalDefaultTranslateId() {
      switch (this.user.salesOrg) {
        case 'GB46':
          return 'ml_132925'
        case 'GB47':
          return 'ml_132926'
        case 'GB49':
          return 'ml_132927'
      }
      return ''
    }
  }
}
